import { useRef } from "react";
import { SENDER_LINE_MAX, SENDER_LINE_PLACEHOLDERS, type Project } from "@omnabase/shared";
import { Pick } from "./Pick";
import { PlaceholderChips } from "./SignatureBlock";

/** Projects › General's Sender control (2026-10-01; the connector tags round, 2026-10-27: a fourth choice, "Custom…"): the pick of the From
 *  name customers see and, while Custom is chosen, the one-line "Sender line" under it with the signature's placeholder chips (no logo: a From
 *  line shows no picture). The card keeps the state, so the mock-up's From line follows every key. */
export type SignAs = NonNullable<Project["signAs"]>;
const CHOICES = ["agent", "person", "team", "custom"] as const satisfies readonly SignAs[];

export function SenderPick({ signAs, line, fromName, disabled, onSignAs, onLine }: { signAs: SignAs; line: string; /** the From name a choice gives, filled for the person looking */ fromName: (v: SignAs) => string; disabled?: boolean; onSignAs: (v: SignAs) => void; onLine: (next: string) => void }) {
  const field = useRef<HTMLInputElement>(null);
  return (
    <div className="ob-sender">
        <Pick label="Sender" value={signAs} options={CHOICES} disabled={disabled} render={(v) => (v === "custom" ? "Custom…" : fromName(v))} display={fromName} onChange={onSignAs} />
      {signAs === "custom" && (
        <div className="ob-sender-line">
          <input ref={field} className="ob-dialog__input ob-sender-line__input" aria-label="Sender line" value={line} maxLength={SENDER_LINE_MAX} disabled={disabled} placeholder="{firstname} at {project}" onChange={(e) => onLine(e.target.value)} />
          <PlaceholderChips field={field} value={line} onChange={onLine} max={SENDER_LINE_MAX} chips={SENDER_LINE_PLACEHOLDERS} disabled={disabled} />
        </div>
      )}
    </div>
  );
}
